import {
    actionAddCatalogItemCategories,
    actionAddEventParam,
    actionAddMusicChannel,
    actionAddMusicSong,
    actionAddPaint,
    actionPreferenceUpdateStore,
    actionAddResources,
    actionAddScene,
    actionAddSceneItem,
    actionAddScheduleEvent,
    actionAddScheduleItem,
    actionAddScheduleSceneItem,
    actionAddTransitionItem,
    actionAddTransitionPool,
    actionCartContentUpdate,
    actionCatalogAddItem,
    actionCatalogAddResource,
    actionChangelistIdUpdate,
    actionCreateCredentials,
    actionCRUDScene,
    actionDestroyDynawebs,
    actionDynawebsServerSuccess,
    actionGetResourcesSharedLibrarySuccess,
    actionLoadAccountFailure,
    actionLoadAccountSuccess,
    actionLoadCartContentSuccess,
    actionLoadCartProductsSuccess,
    actionLoadDynawebsCartProductsSuccess,
    actionLoadDynawebsCartReply,
    actionLoadDynawebsOrderReply,
    actionLoadOrdersSuccess,
    actionLoadOrderSuccess,
    actionLoadStationRemove,
    actionLoadStationsGeoIPSuccess,
    actionLoadStationUpdate,
    actionLoadTemplatesSuccess,
    actionLockRecordUpdate,
    actionPreloginResellerReply,
    actionRemoveCatalogInfos,
    actionRemoveCatalogItemCategories,
    actionRemoveCatalogItems,
    actionRemoveCatalogResource,
    actionRemoveEventParam,
    actionRemoveInSceneItem,
    actionRemoveMusicChannel,
    actionRemoveMusicSong,
    actionRemovePaint,
    actionRemoveResources,
    actionRemoveSceneBlocks,
    actionRemoveScenes,
    actionRemoveScheduleEvent,
    actionRemoveScheduleItem,
    actionRemoveScheduleSceneItem,
    actionRemoveTransitionItems,
    actionSaveCustomerDynawebsReply,
    actionSceneJumpLinked,
    actionSelectedUserUpdate,
    actionSetGlobalConfigReply,
    actionSocialAddProfileKey,
    actionSocialRemoveKey,
    actionStationV1V2Update,
    actionStationV2SocketUpdate,
    actionUpdateAccountDetails,
    actionUpdateBusinessName,
    actionUpdateCatalogItem,
    actionUpdateCatalogItemCategories,
    actionUpdateCatalogItemInfos,
    actionUpdateCatalogItemResource,
    actionUpdateCategoryValue,
    actionUpdateDynawebsOrder,
    actionUpdateEventParams,
    actionUpdateEventsStrings,
    actionUpdateMusicChannel,
    actionUpdatePaint,
    actionUpdateResources,
    actionUpdateSceneItem,
    actionUpdateSceneItemGroup,
    actionUpdateScheduleEvent,
    actionUpdateScheduleItem,
    actionUpdateScripts,
    actionUpdateTransitionItems,
    actionUpdateTransitionPool, actionTwoFactorCheckAccess, actionTwoFactorAuthReply
} from '../actions/user.actions';
import {initialUserState} from '../state/user.state';
import {Action, createReducer} from '@ngrx/store';
import {compareIds, concatIdBusinessId, getDefaultStationStats, getPlayerIdInScene, isNullOrUndef, isNumericValue, NONE_VALUE, preProcessSceneTree, produceOn, UserDataKeyMapping} from "../../common";
import {IMetaDataDetails, IPlayerProps, ISceneBlock, ISceneItemNewValues, ISceneItemsUpdate, ISceneTreeSliceResults, IStationStatsV1, IStationStatsV1V2, IUserState} from "../../interfaces";
import {undoRedo} from 'ngrx-wieder';
import * as _ from 'lodash';
import * as xml2js from 'xml2js';
import {Lib} from "../../../libs/Lib";
import {enableAllPlugins, PatchListener} from "immer";

enableAllPlugins();

const reducer = (state, action, listener?: PatchListener) => {
    return featureReducer(listener)(state, action);
};

const featureReducer = (listener) => createReducer(
    initialUserState,
    /** AUTH | User **/
    produceOn(actionCreateCredentials, (draft, action) => {
        draft.createCredentials = action.createCredentials;
    }),
    produceOn(actionSelectedUserUpdate, (draft, action) => {
        draft.selectedUser = action.user;
    }),
    produceOn(actionUpdateAccountDetails, (draft, action) => {
        draft.userDetails = action.userDetails;
    }),
    produceOn(actionUpdateBusinessName, (draft, action) => {
        draft.selectedUser.businessName = action.businessName;
    }),

    /** LOCK RECORDS **/
    produceOn(actionLockRecordUpdate, (draft, action) => {
        if (action.payload.lockedRecords) {
            draft.lockedRecord = action.payload;
        } else {
            draft.lockedRecord.changelistId = action.payload.changelistId;
        }
    }),
    produceOn(actionChangelistIdUpdate, (draft, action) => {
        draft.changelistId = action.payload.changelistId;
    }),

    /** DYNAWEBS **/
    produceOn(actionLoadDynawebsOrderReply, (draft, action) => {
        draft.dynawebs.order = action.order;
    }),
    produceOn(actionUpdateDynawebsOrder, (draft, action) => {
        draft.dynawebs.order = action.order;
    }),
    produceOn(actionLoadDynawebsCartReply, (draft, action) => {
        draft.dynawebs.cart = action.cart;
    }),
    produceOn(actionLoadDynawebsCartProductsSuccess, (draft, action) => {
        draft.dynawebs.products = action.products;
    }),
    produceOn(actionDestroyDynawebs, (draft, action) => {
        draft.dynawebs.cart = null;
        draft.dynawebs.order = null;
        draft.dynawebs.products = null;
    }),
    produceOn(actionDynawebsServerSuccess, (draft, action) => {
        draft.dynawebs.dynawebsServer = action.dynawebsServer;
    }),

    /** TABLES **/
    produceOn(actionLoadAccountSuccess, (draft, action) => {
        /** initial dataLoad from server, populate store **/
        draft.lastGetTime = Date.now();
        if (action.changelistId === NONE_VALUE) {
            if (!action.accountData) return;
            Object.keys(action.accountData).forEach((key) => {
                if (!isNullOrUndef(action.accountData[key]))
                    draft[key] = action.accountData[key];
            });
        } else {
            /** multi user update synced from another user so update accordingly **/
            Lib.DevShow('multi user syncing...');
            if (!action.accountData) return;

            Object.keys(action.accountData).forEach((key) => {

                if (key == 'changelistId') {
                    draft[key] = action.changelistId;
                    return;
                }

                const updatedData = action.accountData[key];
                if (isNullOrUndef(updatedData)) return;

                const keyMapping = UserDataKeyMapping[key];
                if (keyMapping) {
                    const uniqueKey = keyMapping['uniqueKey'];

                    updatedData.forEach(row => {

                        // check change_type and if it is equal to 3, it means "deleted"
                        if (row.change_type === 3) {
                            if (key == 'scenes') {
                                _.remove(draft[key], (item) => compareIds(_.get(item, uniqueKey), _.get(row, uniqueKey)));
                            } else {
                                _.remove(draft[key], (item) => compareIds(item[uniqueKey], row[uniqueKey]));
                            }

                        } else {
                            // check row if it is updated or new.
                            let ind;
                            if (key == 'scenes') {
                                ind = draft[key].findIndex((item) => compareIds(_.get(item, uniqueKey), _.get(row, uniqueKey)));
                            } else {
                                ind = draft[key].findIndex((item) => compareIds(item[uniqueKey], row[uniqueKey]));
                            }

                            if (ind === -1) {
                                draft[key].push(row);
                            } else {
                                draft[key][ind] = row;

                                if (key == 'scenes') {
                                    draft.crudScene = {
                                        command: 'rebuild',
                                        sceneId: row.Player.$.id,
                                        itemIds: [],
                                        disableSync: true
                                    };
                                }
                            }
                        }
                    });
                }
            });
        }
    }),

    produceOn(actionLoadAccountFailure, (draft, action) => {
        draft.scenes = [];
    }),

    produceOn(actionPreloginResellerReply, (draft, action) => {
        draft.preLoginResellerInfo = action.resellerInfo;
    }),

    produceOn(actionGetResourcesSharedLibrarySuccess, (draft, action) => {
        draft.resourceSharedLibrary = action.value;
    }),

    produceOn(actionUpdateSceneItem, (draft, action) => {
        const sceneTreeSlice: ISceneTreeSliceResults = getPlayerIdInScene(draft.scenes, action.sceneId, action.sceneItemId);

        action.values.forEach((i_newValues: ISceneItemNewValues) => {
            i_newValues.value = i_newValues.cloneValue ? _.cloneDeep(i_newValues.value) : i_newValues.value;
            if (i_newValues.preProcessFunction)
                return i_newValues.preProcessFunction(i_newValues, draft, action, sceneTreeSlice);
            const path = _.get(sceneTreeSlice.sceneItem, i_newValues.storePath);
            if (_.isUndefined(path) || _.isUndefined(path[i_newValues.key])) {
                Lib.DevShow('Sean appending slice branch dynamically...');
                _.set(sceneTreeSlice.sceneItem, `${i_newValues.storePath}.${i_newValues.key}`, i_newValues.value);
            } else {
                path[i_newValues.key] = i_newValues.value;
            }
        });
        if (!action.disableCRUD) {
            draft.crudScene = {
                command: 'update',
                sceneId: action.sceneId,
                itemIds: [action.sceneItemId]
            };
        }

    }, listener),

    produceOn(actionUpdateSceneItemGroup, (draft, action) => {
        if (!action.items || action.items.length == 0) return;

        action.items.forEach((_item: ISceneItemsUpdate) => {
            const sceneTreeSlice: ISceneTreeSliceResults = getPlayerIdInScene(draft.scenes, _item.sceneId, _item.sceneItemId);
            _item.values.forEach((i_newValues: ISceneItemNewValues) => {
                i_newValues.value = i_newValues.cloneValue ? _.cloneDeep(i_newValues.value) : i_newValues.value;
                if (i_newValues.preProcessFunction)
                    return i_newValues.preProcessFunction(i_newValues, draft, _item, sceneTreeSlice);
                const path = _.get(sceneTreeSlice.sceneItem, i_newValues.storePath);
                if (_.isUndefined(path) || _.isUndefined(path[i_newValues.key])) {
                    Lib.DevShow('Sean appending slice branch dynamically...');
                    _.set(sceneTreeSlice.sceneItem, `${i_newValues.storePath}.${i_newValues.key}`, i_newValues.value);
                } else {
                    path[i_newValues.key] = i_newValues.value;
                }
            });
        });

        if (!action.disableCRUD) {
            draft.crudScene = {
                command: 'update',
                sceneId: action.items[0].sceneId,
                itemIds: action.items.map((_item) => _item.sceneItemId)
            };
        }
    }, listener),

    produceOn(actionAddSceneItem, (draft, action) => {
        const sceneTreeSlice: ISceneTreeSliceResults = getPlayerIdInScene(draft.scenes, action.sceneId, action.sceneItemId);

        action.values.forEach((i_newValues: ISceneItemNewValues) => {
            i_newValues.value = i_newValues.cloneValue ? _.cloneDeep(i_newValues.value) : i_newValues.value;
            if (i_newValues.preProcessFunction)
                return i_newValues.preProcessFunction(i_newValues, draft, action, sceneTreeSlice);

            const path = _.get(sceneTreeSlice.sceneItem, i_newValues.storePath);
            if (!path || (!_.isArray(path[i_newValues.key]) && _.isEmpty(path))) {
                Lib.DevShow('found an empty scene so adding Player key...');
                return _.set(sceneTreeSlice.sceneItem, `${i_newValues.storePath}.Player`, [i_newValues.value]);
            }
            if (isNullOrUndef(i_newValues.addIndex)) {
                path[i_newValues.key].push(i_newValues.value);
            } else {
                path[i_newValues.key].splice(i_newValues.addIndex, 0, i_newValues.value);
            }
        });

        if (action.sceneId == action.sceneItemId && action.updatedItemIds) {
            draft.crudScene = {
                command: 'add',
                sceneId: action.sceneId,
                itemIds: action.updatedItemIds
            };
        } else {
            draft.crudScene = {
                command: 'update',
                sceneId: action.sceneId,
                itemIds: [action.sceneItemId]
            };
        }

    }, listener),

    produceOn(actionAddScene, (draft, action) => {
        draft.scenes.push(action.player);
    }),

    produceOn(actionSceneJumpLinked, (draft, action) => {
        draft.previousLinkedSceneId = action.previousLinkedSceneId;
    }),

    produceOn(actionRemoveScenes, (draft, action) => {
        _.remove(draft.scenes, (i_sceneStore: IPlayerProps) => {
            return action.sceneIds.findIndex((sceneId) => compareIds(i_sceneStore.Player.$.id, sceneId)) > -1;
        });
        // action.scenes.forEach((sceneId, idx1) => {
        //     draft.scenes.forEach((i_sceneStore: IPlayerProps, idx2) => {
        //         if (sceneId === i_sceneStore.Player.$.id) {
        //             draft.scenes.splice(idx2, 1);
        //         }
        //     });
        // });
    }),

    produceOn(actionRemoveInSceneItem, (draft, action) => {
        const sceneTreeSlice: ISceneTreeSliceResults = getPlayerIdInScene(draft.scenes, action.sceneId, action.sceneItemId);
        action.values.forEach((i_newValues: ISceneItemNewValues) => {
            if (i_newValues.preProcessFunction)
                return i_newValues.preProcessFunction(i_newValues, draft, action, sceneTreeSlice);
            const path = _.get(sceneTreeSlice.sceneItem, i_newValues.storePath);
            delete path[i_newValues.key];
        });

        if (!action.disableCRUD) {
            draft.crudScene = {
                command: 'update',
                sceneId: action.sceneId,
                itemIds: [action.sceneItemId]
            };
        }
    }),

    produceOn(actionRemoveSceneBlocks, (draft, action) => {
        const sceneTreeSlice: ISceneTreeSliceResults = getPlayerIdInScene(draft.scenes, action.sceneId, action.sceneId);
        action.values.forEach((i_newValues: ISceneItemNewValues) => {
            const path: [] = _.get(sceneTreeSlice.sceneItem, i_newValues.storePath);
            path.forEach((item: ISceneBlock, idx) => {
                if (item.$.id === i_newValues.value) path.splice(idx, 1);
            });
        });

        if (!action.disableCRUD) {
            draft.crudScene = {
                command: 'delete',
                sceneId: action.sceneId,
                itemIds: action.values.map(v => v.value.toString())
            };
        }
    }, listener),

    // produceOn(actionSwapSceneItems, (draft, action) => {
    //     const sceneTreeSlice: ISceneTreeSliceResults = getPlayerIdInScene(draft.scenes, action.sceneId, action.sceneId);
    //     let players = [];
    //     if (sceneTreeSlice.sceneItem.Data[0].Scene) {
    //         players = sceneTreeSlice.sceneItem.Data[0].Scene[0].Players[0].Player;
    //     }
    //     if (players.length > 1) {
    //         const ind1 = players.findIndex((p1) => p1.$.id == action.sceneItemId1);
    //         const ind2 = players.findIndex((p1) => p1.$.id == action.sceneItemId2);
    //         const tmp = players[ind1];
    //         players[ind1] = players[ind2];
    //         players[ind2] = tmp;
    //     }
    // }, listener),

    /** CART **/
    produceOn(actionLoadCartProductsSuccess, (draft, action) => {
        draft.cart.products = action.cart;
    }),

    produceOn(actionLoadCartContentSuccess, (draft, action) => {
        draft.cart.cartContent = action.payload.cartContent;
        draft.cart.cartVersion = action.payload.cartVersion;
        draft.cart.cartLocation = action.payload.cartLocation;
    }),

    produceOn(actionSetGlobalConfigReply, (draft, action) => {
        if (isNumericValue(action.payload?.payerId) && action.payload?.payerId > 100) {
            draft.selectedUser.payerId = action.payload.payerId;
        }
    }),

    produceOn(actionSaveCustomerDynawebsReply, (draft, action) => {
        draft.selectedUser.payerId = action.payload.payerId;
        // draft.selectedUser.accountType = action.payload.accountType;
    }),

    produceOn(actionCartContentUpdate, (draft, action) => {
        draft.cart.cartLocation = action.payload.cartLocation;
        draft.cart.total = action.payload.total;
        draft.cart.tax = action.payload.tax;
        draft.cart.subTotal = action.payload.subTotal;
        draft.cart.delivery = action.payload.delivery;
    }),

    /** STATIONS **/
    produceOn(actionStationV1V2Update, (draft, action) => {
        /** we never override connection status of a v2 player, as its connection update comes from actionStationV2SocketUpdate so we remember player's connection state, not override  **/
        const snapshotV2 = draft.stationStats.filter((i_station) => i_station.$.version == '2');
        action.stationArray.forEach((i_station) => {
            const i_stationStats: IStationStatsV1V2 = snapshotV2.find((i_snappedV2: IStationStatsV1V2) => i_station.$.station_business_id === i_snappedV2.$.station_business_id);
            if (i_stationStats) {
                i_station.$.connection = i_stationStats.$.connection;
                i_station.$.socket = i_stationStats.$.socket;
                i_station.$.lastUpdate = i_stationStats.$.lastUpdate;
                i_station.$.localIp = i_stationStats.$.localIp;
                i_station.$.playing = i_stationStats.$.playing;
                i_station.$.wdExtension = i_stationStats.$.wdExtension;
                i_station.$.startTime = i_stationStats.$.startTime;
                i_station.$.wdNative = i_stationStats.$.wdNative;
                i_station.$.wdConnected = i_stationStats.$.wdConnected;
                i_station.$.libVersion = i_stationStats.$.libVersion;
                i_station.$.appVersion = i_stationStats.$.appVersion;
                i_station.$.platform = i_stationStats.$.platform;
            }
            _.remove(draft.stationStats, (item) => i_station.$.station_business_id === item.$.station_business_id);
        });
        draft.stationStats = [...draft.stationStats, ...action.stationArray];
    }),

    produceOn(actionStationV2SocketUpdate, (draft, action) => {
        /** we always override v2 socket based players with action  **/
        const item = draft.stationStats.find((v) => {
            return concatIdBusinessId(v.$.id, v.$.businessId, v.$.version) == concatIdBusinessId(action.id, v.$.businessId, v.$.version);
        });
        if (item) {
            Object.keys(action.value).forEach((k) => item.$[k] = action.value[k]);
        } else {
            const player: IStationStatsV1 = getDefaultStationStats(concatIdBusinessId(action.id, action.businessId, '2'), action.id, '2');
            Object.keys(action.value).forEach((k) => player.$[k] = action.value[k]);
            draft.stationStats.push(player);
        }
    }),

    produceOn(actionLoadStationUpdate, (draft, action) => {
        if (draft.stations) {
            const item = draft.stations.find((v) => compareIds(v.station_business_id, action.value.station_business_id));
            Object.keys(action.value).forEach((k) => {
                item[k] = action.value[k];
            });
        }
    }),

    produceOn(actionLoadStationRemove, (draft, action) => {
        if (draft.stations) {
            _.remove(draft.stations, (item) => action.stationIds.findIndex((_id) => compareIds(item.station_id, _id)) > -1);
        }
    }),

    produceOn(actionLoadStationsGeoIPSuccess, (draft, action) => {
        draft.userStationGeoIPs = action.stationArray;
    }),

    // produceOn(actionLoadTrackingStationSuccess, (draft, action) => {
    //     draft.userStationTrack = action.stationTrackReply;
    // }),

    // produceOn(actionLoadTrackingStationStatsSuccess, (draft, action) => {
    //     draft.userStationTrackStats = action.stationTrackReply;
    // }),

    /** TEMPLATES **/
    produceOn(actionLoadTemplatesSuccess, (draft, action) => {
        draft.sceneTemplateImports = action.sceneTemplateImports;
    }),

    /** RESOURCES **/
    produceOn(actionUpdateResources, (draft, action) => {
        if (action.resourcesId) {
            const item = draft.resources.find((v) => compareIds(v.resource_id, action.resourcesId));
            item.resource_name = action.resource_name;
            item.tree_path = action.tree_path;
            item.access_key = action.access_key;
        }
    }),

    produceOn(actionAddResources, (draft, action) => {
        if (action.data) {
            if (!draft.resources.find((v) => compareIds(v.resource_id, action.data.resource_id))) {
                draft.resources.unshift(action.data);
            }
        }
    }),

    produceOn(actionRemoveResources, (draft, action) => {
        if (draft.resources) {
            _.remove(draft.resources, (item) => action.resourceIds.findIndex((_id) => compareIds(item.resource_id, _id)) > -1);
        }
    }),

    /** CATEGORY **/
    produceOn(actionUpdateCategoryValue, (draft, action) => {
        draft.categoryValues = action.data.categoryValues;
    }, listener),

    /** GLOBAL SETTINGS **/
    produceOn(actionSocialAddProfileKey, (draft, action) => {
        draft.globalSettings.unshift({
            param_key: action.data.param_key,
            param_id: action.data.param_id,
            param_value: action.data.param_value
        });
    }),
    produceOn(actionSocialRemoveKey, (draft, action) => {
        if (draft.globalSettings) {
            _.remove(draft.globalSettings, (item) => compareIds(item.param_id, action.paramId));
        }
    }),

    /** CATALOG **/
    produceOn(actionUpdateCatalogItem, (draft, action) => {
        draft.catalogItems = action.data.catalogItems;
    }),

    produceOn(actionCatalogAddItem, (draft, action) => {
        draft.catalogItems.unshift({
            catalog_item_id: action.data.catalog_item_id,
            item_name: action.data.item_name
        });
        draft.catalogItemInfos.unshift({
            catalog_item_id: action.data.catalog_item_id,
            info0: '',
            info1: '',
            info2: '',
            info3: ''
        });
    }),

    produceOn(actionCatalogAddResource, (draft, action) => {
        draft.catalogItemResources.unshift({
            catalog_item_id: action.catalogItemId,
            resource_id: action.resourceId,
            catalog_item_resource_id: action.catalogItemResourceId
        });
    }),

    produceOn(actionRemoveCatalogResource, (draft, action) => {
        action.catalogItemResources.forEach((v) => {
            _.remove(draft.catalogItemResources, (item) => {
                if (v.catalog_item_id) {
                    return compareIds(item.catalog_item_id, v.catalog_item_id);
                } else if (v.resource_id) {
                    return compareIds(item.resource_id, v.resource_id);
                } else if (v.catalog_item_resource_id) {
                    return compareIds(item.catalog_item_resource_id, v.catalog_item_resource_id);
                }
            });
        });
    }),

    produceOn(actionRemoveCatalogInfos, (draft, action) => {
        _.remove(draft.catalogItemInfos, (item) => compareIds(item.catalog_item_id, action.catalogItemId));
    }),

    produceOn(actionRemoveCatalogItems, (draft, action) => {
        _.remove(draft.catalogItems, (item) => compareIds(item.catalog_item_id, action.catalogItemId));
    }),

    produceOn(actionRemoveCatalogItemCategories, (draft, action) => {
        action.catalogItemCategories.forEach((v) => {
            _.remove(draft.catalogItemCategories, (item) => {
                if (v.catalog_item_id) {
                    return compareIds(item.catalog_item_id, v.catalog_item_id);
                } else if (v.category_value_id) {
                    return compareIds(item.category_value_id, v.category_value_id);
                } else if (v.catalog_item_category_id) {
                    return compareIds(item.catalog_item_category_id, v.catalog_item_category_id);
                } else {
                    return false;
                }
            });
        });
    }),

    produceOn(actionUpdateCatalogItemInfos, (draft, action) => {
        if (action.catalogItemInfoId) {
            const catalogItemInfos = draft.catalogItemInfos.find((item) => item.catalog_item_id === action.catalogItemInfoId);
            if (action.key in catalogItemInfos) {
                catalogItemInfos[action.key] = action.value;
            }
        }
    }),

    produceOn(actionUpdateCatalogItemResource, (draft, action) => {
        if (action.catalogItemResourceId) {
            const catalogItemInfos = draft.catalogItemResources.find((item) => item.catalog_item_resource_id === action.catalogItemResourceId);
            if (action.key in catalogItemInfos) {
                catalogItemInfos[action.key] = action.value;
            }
        }
    }),

    produceOn(actionUpdateCatalogItemCategories, (draft, action) => {
        draft.catalogItemCategories = action.catalogItemCategories;
    }),

    produceOn(actionAddCatalogItemCategories, (draft, action) => {
        draft.catalogItemCategories = draft.catalogItemCategories.concat(action.catalogItemCategories);
    }),

    /** ORDERS **/
    produceOn(actionLoadOrdersSuccess, (draft, action) => {
        draft.orders = action.orders;
    }),

    produceOn(actionLoadOrderSuccess, (draft, action) => {
        draft.order = action.order;
    }),

    /** EVENTS **/
    produceOn(actionUpdateEventParams, (draft, action) => {
        if (action.eventParamId) {
            const eventParam = draft.eventParams.find((item) => item.event_param_id === action.eventParamId);
            if (action.key in eventParam) {
                eventParam[action.key] = action.value;
            }
        } else if (action.eventParamId == null) {
            draft.eventParams = action.value;
        }
    }),
    produceOn(actionAddEventParam, (draft, action) => {
        draft.eventParams.unshift({
            event_param_id: action.data.event_param_id,
            event_name: action.data.event_name,
            event_value: action.data.event_value,
            access_key: action.data.access_key
        });
    }),
    produceOn(actionRemoveEventParam, (draft, action) => {
        draft.eventParams = draft.eventParams.filter((v) => {
            return v.event_param_id !== action.eventParamId;
        });
    }),

    produceOn(actionUpdateEventsStrings, (draft, action) => {
        // remove duplicates
        if (action.eventsStrings.length == 0) {
            let eventsStrings = [];
            if (initialUserState.scenes) {
                Object.keys(initialUserState.scenes).forEach((key: string, idx) => {
                    xml2js.parseString(initialUserState.scenes[key].player_data_value, (err, sceneData: IPlayerProps) => {
                        const eventNames = preProcessSceneTree(sceneData, key);
                        if (eventNames.length > 0) {
                            eventsStrings = [...eventsStrings, ...eventNames];
                            eventsStrings = [...new Set(eventsStrings)];
                        }
                    });
                });
                draft.eventsStrings = eventsStrings;
            }

        } else {
            draft.eventsStrings = [...new Set([...draft.eventsStrings, ...action.eventsStrings])];
        }
    }),

    /** Transitions */
    produceOn(actionAddTransitionItem, (draft, action) => {
        draft.transitionPoolItems.unshift({
            transition_pool_item_id: action.data.transition_pool_item_id,
            transition_pool_id: action.data.transition_pool_id,
            transition_item_name: action.data.transition_item_name,
            transition_item_data: action.data.transition_item_data
        });
    }),
    produceOn(actionAddTransitionPool, (draft, action) => {
        draft.transitionPools.push({
            id: action.data.id,
            transition_pool_name: action.data.transition_pool_name
        });
    }),
    produceOn(actionUpdateTransitionItems, (draft, action) => {
        if (!action.transition_pool_id) {
            draft.transitionPoolItems = action.value;
            return;
        }

        draft.transitionPoolItems
            .filter((p) => {
                if (action.transition_pool_item_id) {
                    return compareIds(p.transition_pool_id, action.transition_pool_id)
                        && compareIds(p.transition_pool_item_id, action.transition_pool_item_id);
                } else {
                    return compareIds(p.transition_pool_id, action.transition_pool_id);
                }
            })
            .forEach((p) => {
                if (_.isEmpty(action.store_path)) {
                    _.set(p, `${action.key}`, action.value);
                } else {
                    _.set(p, `${action.store_path}.${action.key}`, action.value);
                }

            });
    }),
    produceOn(actionUpdateTransitionPool, (draft, action) => {
        if (!action.transition_pool_id) {
            draft.transitionPools = action.value;
            return;
        }
        const pool = draft.transitionPools.find((p) => compareIds(p.id, action.transition_pool_id));
        pool[action.key] = action.value;
    }),
    produceOn(actionRemoveTransitionItems, (draft, action) => {
        _.remove(draft.transitionPoolItems, (item) => {
            if (compareIds(item.transition_pool_id, action.transition_pool_id)) {
                if (action.transition_pool_item_id) {
                    if (compareIds(item.transition_pool_item_id, action.transition_pool_item_id)) {
                        return true;
                    }
                } else {
                    return true;
                }
            }
            return false;
        });
    }),

    /** Music reducers */
    produceOn(actionAddMusicChannel, (draft, action) => {
        draft.musicChannels.unshift({
            music_channel_id: action.data.music_channel_id,
            music_channel_name: action.data.music_channel_name,
            access_key: action.data.access_key ? action.data.access_key : '0',
            tree_path: action.data.tree_path ? action.data.tree_path : '',
            folder: action.data.folder ? action.data.folder : ''
        });
    }),

    produceOn(actionRemoveMusicChannel, (draft, action) => {
        _.remove(draft.musicChannels, (item) => compareIds(item.music_channel_id, action.music_channel_id));
    }),

    produceOn(actionAddMusicSong, (draft, action) => {
        draft.musicChannelSongs.unshift(action.data);
    }),

    produceOn(actionUpdateMusicChannel, (draft, action) => {
        if (action.music_channel_id) {
            const musicChannel = draft.musicChannels.find((item) => item.music_channel_id === action.music_channel_id);
            if (action.key in musicChannel) {
                musicChannel[action.key] = action.value;
                if (action.key == 'tree_path') {
                    musicChannel['folder'] = action.value;
                }
            }
        } else if (action.music_channel_id == null) {
            draft.musicChannels = action.value;
        }
    }),

    produceOn(actionRemoveMusicSong, (draft, action) => {
        _.remove(draft.musicChannelSongs, (item) => compareIds(item.music_channel_song_id, action.music_channel_song_id));
    }),

    /** Preferences reducers */
    produceOn(actionPreferenceUpdateStore, (draft, action) => {
        Object.keys(action.preferencesBusiness).forEach((i_key) => {
            draft.preferences[i_key] = action.preferencesBusiness[i_key];
        });
    }),

    produceOn(actionTwoFactorCheckAccess, (draft, action) => {
        draft.twoFactorState = action.status;
    }),

    produceOn(actionTwoFactorAuthReply, (draft, action) => {
        if (action?.replay?.action === 'check' && action.replay.status === true){
            draft.twoFactorState = true;
        }
    }),

    /** Painter reducers */
    produceOn(actionAddPaint, (draft, action) => {
        draft.painters.unshift(action.data);
    }),

    produceOn(actionUpdatePaint, (draft, action) => {
        if (!action.id) {
            draft.painters = action.data;
            return;
        }
        const paint = draft.painters.find((p) => compareIds(p.id, action.id));
        if (paint) {
            paint[action.key] = action.data;
        }
    }),

    produceOn(actionRemovePaint, (draft, action) => {
        _.remove(draft.painters, (item) => compareIds(item.id, action.id));
    }),

    /** Scheduler reducers */
    produceOn(actionAddScheduleSceneItem, (draft, action) => {
        const scene = draft.scenes.find((i_sceneStore: IPlayerProps) => compareIds(action.sceneId, i_sceneStore.Player.$.id));
        if (!scene) return;
        const metaDataDetails: IMetaDataDetails = {Schedules: [{Schedule: action.schedulerIds}]};
        _.set(scene, `Player.Metadata[0]`, metaDataDetails);
    }),

    produceOn(actionRemoveScheduleSceneItem, (draft, action) => {
        const scene = draft.scenes.find((i_sceneStore: IPlayerProps) => compareIds(action.sceneId, i_sceneStore.Player.$.id));
        if (scene) {
            scene.Player.Metadata[0].Schedules[0].Schedule = scene.Player.Metadata[0].Schedules[0].Schedule.filter((v) => {
                return !compareIds(v.$.id, action.schedulerId.$.id);
            });
        }
    }),

    produceOn(actionAddScheduleItem, (draft, action) => {
        draft.schedules.unshift(action.data);
    }),

    produceOn(actionUpdateScheduleItem, (draft, action) => {
        if (!action.schedule_id) {
            draft.schedules = action.values;
            return;
        }
        const item = draft.schedules.find((s) => compareIds(s.schedule_id, action.schedule_id));
        if (item) {
            action.values.forEach((v) => {
                item[v.key] = v.value;
            });
        }
    }),

    produceOn(actionRemoveScheduleItem, (draft, action) => {
        _.remove(draft.schedules, (item) => compareIds(item.schedule_id, action.schedule_id));
    }),

    produceOn(actionAddScheduleEvent, (draft, action) => {
        draft.scheduleEvents.unshift(...action.data);
    }, listener),

    produceOn(actionUpdateScheduleEvent, (draft, action) => {

        // update entire schedule events
        if (!action.schedule_id && !action.schedule_event_id) {
            draft.scheduleEvents = action.data;
            return;
        }

        // update all events of a schedule
        if (!action.schedule_event_id) {
            action.data.forEach((i_event) => {
                const ind = draft.scheduleEvents.findIndex((s) =>
                    compareIds(s.schedule_event_id, i_event.schedule_event_id) && compareIds(s.schedule_id, action.schedule_id));
                draft.scheduleEvents.splice(ind, 1, i_event);
            });
            return;
        }

        // update the properties of one schedule event
        const item = draft.scheduleEvents.find((s) =>
            compareIds(s.schedule_event_id, action.schedule_event_id) && compareIds(s.schedule_id, action.schedule_id));
        if (item) {
            action.data.forEach((v) => {
                item[v.key] = v.value;
            });
        }
    }, listener),

    produceOn(actionRemoveScheduleEvent, (draft, action) => {
        action.schedule_event_ids.forEach((e_id) => {
            _.remove(draft.scheduleEvents, (item) => compareIds(item.schedule_event_id, e_id));
        });

    }, listener),

    produceOn(actionCRUDScene, (draft, action) => {
        draft.crudScene = action.data;
    }),

    produceOn(actionUpdateScripts, (draft, action) => {
        const scene = draft.scenes.find((i_sceneStore: IPlayerProps) => compareIds(action.sceneId, i_sceneStore.Player.$.id));
        if (scene) {
            if (!scene.Player.Scripts || !scene.Player.Scripts[0]) {
                scene.Player.Scripts = [{}];
            }
            scene.Player.Scripts['0'].Script = action.data;

            draft.crudScene = {
                command: 'update',
                sceneId: action.sceneId,
                itemIds: []
            };
        }
        // action.values.forEach((i_newValues: ISceneItemNewValues) => {
        //     i_newValues.value = i_newValues.cloneValue ? _.cloneDeep(i_newValues.value) : i_newValues.value;
        //     if (i_newValues.preProcessFunction)
        //         return i_newValues.preProcessFunction(i_newValues, draft, action, sceneTreeSlice);
        //     const path = _.get(sceneTreeSlice.sceneItem, i_newValues.storePath);
        //     if (_.isUndefined(path) || _.isUndefined(path[i_newValues.key])) {
        //         Lib.DevShow('Sean appending slice branch dynamically...');
        //         _.set(sceneTreeSlice.sceneItem, `${i_newValues.storePath}.${i_newValues.key}`, i_newValues.value);
        //     } else {
        //         path[i_newValues.key] = i_newValues.value;
        //     }
        // });
    })
);

const {wrapReducer} = undoRedo({
    allowedActionTypes: [
        actionAddSceneItem.type,
        actionRemoveSceneBlocks.type,
        actionUpdateSceneItem.type,
        actionUpdateSceneItemGroup.type,
        actionUpdateCategoryValue.type,
        actionAddScheduleEvent.type,
        actionUpdateScheduleEvent.type,
        actionRemoveScheduleEvent.type
    ],
    mergeActionTypes: [
        actionUpdateSceneItem.type
    ],
    redoActionType: "REDO",
    undoActionType: "UNDO",
    breakMergeActionType: "BREAK_MERGE",
    clearActionType: "CLEAR"
});

// wrap reducer inside meta-reducer to make it undoable
const undoableReducer = wrapReducer(reducer);

export function userReducers(state: IUserState | undefined = initialUserState, action: Action): IUserState {
    return undoableReducer(state, action);
}
